"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDepGraph = void 0;
const dep_graph_1 = require("@snyk/dep-graph");
const dependency_1 = require("./dependency");
function buildDepGraph(mavenGraph, includeTestScope = false) {
    const { rootId, nodes } = mavenGraph;
    const { pkgInfo: root } = getPkgInfo(rootId);
    const builder = new dep_graph_1.DepGraphBuilder({ name: 'maven' }, root);
    const visited = {};
    const queue = [];
    queue.push(...getItems(rootId, nodes[rootId]));
    // breadth first search
    while (queue.length > 0) {
        const item = queue.shift();
        if (!item)
            continue;
        const { id, parentId } = item;
        const { pkgInfo, scope } = getPkgInfo(id);
        const node = nodes[id];
        if (!includeTestScope && scope === 'test' && !node.reachesProdDep)
            continue;
        if (visited[id]) {
            const prunedId = id + ':pruned';
            builder.addPkgNode(pkgInfo, prunedId, { labels: { pruned: 'true' } });
            builder.connectDep(parentId, prunedId);
            continue; // don't queue any more children
        }
        const parentNodeId = parentId === rootId ? builder.rootNodeId : parentId;
        builder.addPkgNode(pkgInfo, id);
        builder.connectDep(parentNodeId, id);
        queue.push(...getItems(id, node));
        visited[id] = true;
    }
    return builder.build();
}
exports.buildDepGraph = buildDepGraph;
function getItems(parentId, node) {
    const items = [];
    for (const id of (node === null || node === void 0 ? void 0 : node.dependsOn) || []) {
        items.push({ id, parentId });
    }
    return items;
}
function getPkgInfo(value) {
    const { groupId, artifactId, version, scope } = (0, dependency_1.parseDependency)(value);
    return {
        pkgInfo: {
            name: `${groupId}:${artifactId}`,
            version,
        },
        scope,
    };
}
//# sourceMappingURL=dep-graph.js.map